import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { css } from "styled-components";

Object.assign(headerStyles, {
    ...headerStyles,
    saveButton: {
        css: css`
            margin-left: 10px;
            :hover {
                background-color: #ab161a;
                border-color: #ab161a;
            }
        `,
    },
});
